export const captions = [
  {
    abbreviation: 'EB',
    meaning: 'Exército Brasileiro'
  },
  {
    abbreviation: 'PF',
    meaning: 'Polícia Federal'
  },
  {
    abbreviation: 'PC',
    meaning: 'Polícia Civil'
  },
]



// WEBPACK FOOTER //
// ./src/utils/captions.js